import React, { Suspense, useReducer, useState, useEffect } from 'react';
import { Tabs, Tab } from 'carbon-components-react';
import ALERT_HEADERS from 'components/ManageAutomationPage/Alerts/data/sap_alert_headers';
import INCIDENTS_USERS_HEADERS from 'components/ManageAutomationPage/Alerts/data/incidents_user_headers';
import PREDICTED_ALERT_HEADERS from 'components/ManageAutomationPage/Alerts/data/predicted_alert_headers';
import INFRA_ALERT_HEADERS from 'components/ManageAutomationPage/Alerts/data/infra_alert_headers';
import INFRA_INFORMATIONAL_HEADERS from './Alerts/data/infra_informational_headers';
import INCIDENTS_BUISNESS_HEADERS from './Alerts/data/incidents_buisness_headers';
import SYSTEM_RECOMMENDATION_HEADERS from './Alerts/data/system_recommendation_headers';
import INFRA_SECURITY_HEADERS from './Alerts/data/infra_Security_headers';

import i18n from "../../i18n";
import callGetApi from "../../requests/GetRequests";
import * as Constants from '../../requests/URLConstants';
var config = require('../../config/appConfig.json');

const Alerts = React.lazy(() => import('components/ManageAutomationPage/Alerts/Alerts'));

const tabProps1 = {
    tabs: {
        selected: 0,
        type: 'container'
    },
    tab: {
        tabIndex: 0,
    },
};

const tabProps2 = {
    tabs: {
        selected: 0,
        type: 'container'
    },
    tab: {
        tabIndex: 0,
    },
};

function alertFilterDataReducer(state, action) {
    switch (action.type) {
        case "add_franchise":
            return { ...state, franchises: action.item };
        case "add_clients":
            return { ...state, clients: action.item };
        case "add_technologies":
            return { ...state, technologies: action.item };
        case "add_deployment_models":
            return { ...state, deployment_models: action.item };
        case "add_geos":
            return { ...state, geos: action.item };
        case "add_competencies":
            return { ...state, competencies: action.item };
        case "add_priorities":
            return { ...state, priorities: action.item };
        case "add_assignee":
            return { ...state, assignees: action.item };
        case "add_assignee_email":
            return { ...state, assignees_email: action.item };
        case "add_assignee_gp":
            return { ...state, assignee_gp: action.item };
        case "add_incidentStatus":
            return { ...state, incidentStatus: action.item };
        case "add_sid":
            return { ...state, sid: action.item };
        default:
            return { ...state };

    }
}
function pAlertFilterDataReducer(state, action) {
    switch (action.type) {
        case "add_franchise":
            return { ...state, franchises: action.item };
        case "add_clients":
            return { ...state, clients: action.item };
        case "add_assignee":
            return { ...state, assignee: action.item };
        case "add_priorities":
            return { ...state, priority: action.item };
        case "add_incidentStatus":
            return { ...state, incidentStatus: action.item };
        case "add_provider":
            return { ...state, provider: action.item };
        default:
            return { ...state };

    }
}



const SAPOpsWorkspace = (props) => {
    const [loadedTabs, setLoadedTabs] = useState(['incidents', 'infra_failures']);
    const [alertFilterData, alertFilterDispatch] = useReducer(alertFilterDataReducer, { clients: [] });
    const [alertFilterSelections, setAlertFilterSelections] = useState({ 'franchise': [], 'client': [], 'technology': [], 'deployment_model': [], 'geo': [], "competency": [], 'priority': [], 'status': [], 'assignee': [], 'assignee_email': [], 'assignee_gp': [], 'sid': [], 'incidentStatus': [] });
    const [pAlertFilterData, pAlertFilterDispatch] = useReducer(pAlertFilterDataReducer, { clients: [] });
    const [pAlertFilterSelections, setPAlertFilterSelections] = useState({ 'franchise': [], 'client': [], 'priority': [], 'assignee': [], 'incidentStatus': [], 'provider': [] });
    const [disabledSelects, setDisabledSelects] = useState({ 'client-select': true });
    const [alertHeaders, setAlertHeaders] = useState(ALERT_HEADERS);
    const [incidentUserHeaders, setIncidentUserHeaders] = useState(INCIDENTS_USERS_HEADERS);
    const [predictedAlertHeaders, setPredictedAlertHeaders] = useState(PREDICTED_ALERT_HEADERS);
    const [predictedInfraAlertHeaders, setPredictedInfraAlertHeaders] = useState(INFRA_ALERT_HEADERS);
    const [infraInformationalHeaders, setInfraInformationalHeaders] = useState(INFRA_INFORMATIONAL_HEADERS);
    const [incidentBuisnessHeaders, setIncidentBuisnessHeaders] = useState(INCIDENTS_BUISNESS_HEADERS);
    const [SystemRecommendationHeaders, setSystemRecommendationHeaders] = useState(SYSTEM_RECOMMENDATION_HEADERS);
    const [infraSecurityHeaders, setInfraSecurityHeaders] = useState(INFRA_SECURITY_HEADERS);
    const [selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => {
        if (props.userPrefs && props.userPrefs.alertFilters) { setAlertFilterSelections(props.userPrefs.alertFilters); }
        if (props.userPrefs && props.userPrefs.pAlertFilters) { setPAlertFilterSelections(props.userPrefs.pAlertFilters); }


        callGetApi(Constants.GETSAPALERTSFILTERDATAURL, { 'Content-Type': 'application/json' })
            .then(resp => {
                //console.log('response', resp);

                if (resp.body.aggregations.franchises) {
                    let franchiseList = [];
                    resp.body.aggregations.franchises.buckets.forEach(element => {
                        let franchise = {};
                        franchise.name = element.key;
                        franchiseList.push(franchise);
                    });
                    alertFilterDispatch({ type: "add_franchise", item: franchiseList });
                }

                if (resp.body.aggregations.technologies) {
                    let technologiesList = [];
                    resp.body.aggregations.technologies.buckets.forEach(element => {
                        let technology = {};
                        technology.name = element.key;
                        technologiesList.push(technology);
                    });
                    alertFilterDispatch({ type: "add_technologies", item: technologiesList });
                }

                if (resp.body.aggregations.deployment_models.buckets) {
                    let deployment_modelsList = [];
                    resp.body.aggregations.deployment_models.buckets.forEach(element => {
                        let deployment_model = {};
                        deployment_model.name = element.key;
                        deployment_modelsList.push(deployment_model);
                    });
                    alertFilterDispatch({ type: "add_deployment_models", item: deployment_modelsList });
                }

                if (resp.body.aggregations.geos.buckets) {
                    let geosList = [];
                    resp.body.aggregations.geos.buckets.forEach(element => {
                        let geo = {};
                        geo.name = element.key;
                        geosList.push(geo);
                    });
                    alertFilterDispatch({ type: "add_geos", item: geosList });
                }

                if (resp.body.aggregations.competencies.buckets) {
                    let competenciesList = [];
                    resp.body.aggregations.competencies.buckets.forEach(element => {
                        let competency = {};
                        competency.name = element.key;
                        competenciesList.push(competency);
                    });
                    alertFilterDispatch({ type: "add_competencies", item: competenciesList });
                }

                if (resp.body.aggregations.priorities.buckets) {
                    let prioritiesList = [];
                    resp.body.aggregations.priorities.buckets.forEach(element => {
                        let priority = {};
                        priority.name = element.key.toString();
                        prioritiesList.push(priority);
                    });
                    alertFilterDispatch({ type: "add_priorities", item: prioritiesList });
                }
                if (resp.body.aggregations.assigned_to.buckets) {
                    let assignedList = [];
                    resp.body.aggregations.assigned_to.buckets.forEach(element => {
                        let assigned = {};
                        assigned.name = element.key;
                        assignedList.push(assigned);
                    });
                    alertFilterDispatch({ type: "add_assignee", item: assignedList });
                }
                if (resp.body.aggregations.assigned_to_user_id.buckets) {
                    let assignedEmailList = [];
                    resp.body.aggregations.assigned_to_user_id.buckets.forEach(element => {
                        let assignedEmail = {};
                        assignedEmail.name = element.key;
                        assignedEmailList.push(assignedEmail);
                    });
                    alertFilterDispatch({ type: "add_assignee_email", item: assignedEmailList });
                }

                if (resp.body.aggregations.assignment_gp.buckets) {
                    let assignedGpList = [];
                    resp.body.aggregations.assignment_gp.buckets.forEach(element => {
                        let assignedGp = {};
                        assignedGp.name = element.key;
                        assignedGpList.push(assignedGp);
                    });
                    console.log("assignedGpList", assignedGpList);
                    alertFilterDispatch({ type: "add_assignee_gp", item: assignedGpList });
                }
                if (resp.body.aggregations.incidentStatus) {
                    let incidentStatusList = [];
                    resp.body.aggregations.incidentStatus.buckets.forEach(element => {
                        let incidentStatus = {};
                        incidentStatus.name = element.key;
                        incidentStatusList.push(incidentStatus);
                    });
                    alertFilterDispatch({ type: "add_incidentStatus", item: incidentStatusList });
                }
            }).catch((error) => {
                console.error('Error:', error);
            });

        callGetApi(Constants.GETPREDECTIVESAPALERTSFILTERDATAURL, { 'Content-Type': 'application/json' })
            .then(resp => {
                //console.log('sapopsresponse', resp);

                if (resp.body.aggregations.franchises.buckets) {
                    let franchiseList = [];
                    resp.body.aggregations.franchises.buckets.forEach(element => {
                        let franchise = {};
                        franchise.name = element.key;
                        franchiseList.push(franchise);
                    });

                    pAlertFilterDispatch({ type: "add_franchise", item: franchiseList });
                }
                if (resp.body.aggregations.priorities.buckets) {
                    let prioritiesList = [];
                    resp.body.aggregations.priorities.buckets.forEach(element => {
                        let priority = {};
                        priority.name = element.key;
                        prioritiesList.push(priority);
                    });
                    pAlertFilterDispatch({ type: "add_priorities", item: prioritiesList });
                }
                // if (resp.body.aggregations.deployment_models.buckets) {
                //   let deployment_modelsList = [];
                //   resp.body.aggregations.deployment_models.buckets.forEach(element => {
                //     let deployment_model = {};
                //     deployment_model.name = element.key;
                //     deployment_modelsList.push(deployment_model);
                //   });
                //   pAlertFilterDispatch({ type: "add_deployment_models", item: deployment_modelsList });
                // }
                if (resp.body.aggregations.incidentStatus) {
                    let incidentStatusList = [];
                    resp.body.aggregations.incidentStatus.buckets.forEach(element => {
                        let incidentStatus = {};
                        incidentStatus.name = element.key;
                        incidentStatusList.push(incidentStatus);
                    });
                    pAlertFilterDispatch({ type: "add_incidentStatus", item: incidentStatusList });
                }

                if (resp.body.aggregations.assigned_to.buckets) {
                    let assignedList = [];
                    resp.body.aggregations.assigned_to.buckets.forEach(element => {
                        let assigned = {};
                        assigned.name = element.key;
                        assignedList.push(assigned);
                    });
                    pAlertFilterDispatch({ type: "add_assignee", item: assignedList });
                }
                if (resp.body.aggregations.provider.buckets) {
                    let providerList = [];
                    resp.body.aggregations.provider.buckets.forEach(element => {
                        let provider = {};
                        provider.name = element.key;
                        providerList.push(provider);
                    });
                    pAlertFilterDispatch({ type: "add_provider", item: providerList });
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
    }, [props.userPrefs]);

    useEffect(() => {
        if (props.selectedTab === 'Log Anomalies') {
            setSelectedIndex(1);
            setLoadedTabs([...loadedTabs, 'log_anomalies']);
        }
        else if (props.selectedTab === 'Informational') {
            setSelectedIndex(2);
            setLoadedTabs([...loadedTabs, 'informational']);
        }
        else if (props.selectedTab === 'Security Alerts') {
            setSelectedIndex(3);
            setLoadedTabs([...loadedTabs, 'SecurityAlert']);
        }
        else {
            setSelectedIndex(0);
            setLoadedTabs([...loadedTabs, 'infra_failures']);
        }
    }, [props.selectedTab])

    const handleTabClick = (e) => {
        if (e && e.target && e.target.id) {
            console.log(e.target.id);
            if (e.target.id === 'log_anomalies') {
                setSelectedIndex(1);
                props.handleTabSelected('Log Anomalies');
            }
            else if (e.target.id === 'informational') {
                setSelectedIndex(2);
                props.handleTabSelected('Informational')
            }
            else if (e.target.id === 'SecurityAlert') {
                setSelectedIndex(3);
                props.handleTabSelected('Security Alerts')
            }
            else {
                setSelectedIndex(0);
                props.handleTabSelected('Infra Failures')
            }
            setLoadedTabs([...loadedTabs, e.target.id]);
        }
    };


    const updateState = (state, stateValue, type) => {
        //console.log('got here');
        switch (state) {
            case 'alertFilterSelections':
                setAlertFilterSelections(stateValue);
                props.updateState('userPreferences', { 'alertFilterSelections': stateValue });
                break;
            case 'pAlertFilterSelections':
                setPAlertFilterSelections(stateValue);
                props.updateState('userPreferences', { 'pAlertFilterSelections': stateValue });
                break;
            case 'disabledSelects':
                setDisabledSelects(stateValue);
                break;
            case 'alertFilterData_clients':
                alertFilterDispatch({ type: "add_clients", item: stateValue });
                break;
            case 'pAlertFilterData_clients':
                pAlertFilterDispatch({ type: "add_clients", item: stateValue });
                break;
            case 'cardInfo':
                props.updateState('cardInfo', stateValue);
                break;
            case 'alertHeaders':
                if (type === 'Alert') {
                    setAlertHeaders(stateValue);
                } else if (type === 'UserAlert') {
                    setIncidentUserHeaders(stateValue);
                } else if (type === 'UserBuisness') {
                    setIncidentBuisnessHeaders(stateValue);
                } else if (type === 'SystemRecommendations') {
                    setSystemRecommendationHeaders(stateValue);
                }
                else {
                    setPredictedAlertHeaders(stateValue);
                }
                break;
            default:
        }
    };
    console.log(selectedIndex);
    /*
      const setUserPreferences = async (user) => {
        let body = { 'user': user };
        let filterPrefs = {};
        let response = await fetch(config.serverUrl + '/api/alerts/getUserPreferences', {
          method: 'POST',
          credentials: "include",
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json'
          },
     //     redirect: 'follow', // manual, *follow, error
     //     referrerPolicy: 'no-referrer',
          body: JSON.stringify(body)
        });
        let respJson = await response.json();
    
        if (respJson.body && respJson.body._source) {
          //console.log("preferences result", respJson);
    
          if (respJson.body._source.pAlertFilters) {
            setPAlertFilterSelections(respJson.body._source.pAlertFilters);
          }
          if (respJson.body._source.alertFilters) {
            filterPrefs.alertFilters = respJson.body._source.alertFilters;
          }
        } 
      }
    */
    const Informational = i18n.t('manageAutomation.Informational');
    const AlertsLabel = i18n.t('manageAutomation.Alerts');
    const otherAnomalies = i18n.t('manageAutomation.otherAnomalies');
    const LongRunning = i18n.t('manageAutomation.LongRunning');
    const All = i18n.t('manageAutomation.All');
    const Incidents = i18n.t('manageAutomation.Incidents');
    const IncidentSystem = i18n.t('manageAutomation.IncidentSystem');
    const IncidentsUser = i18n.t('manageAutomation.IncidentsUser');
    const IncidentsBuisness = i18n.t('manageAutomation.IncidentsBuisness');
    const SystemRecommendations = i18n.t('manageAutomation.SystemRecommendations');
    const logAnomalies = i18n.t('sapOps.logAnomalies');
    const infraFailures = i18n.t('sapOps.infraFailures');
    const securityAlerts = i18n.t('sapOps.securityAlerts')
    return (
        <div>
            {/* <div className="bx--row bx--grid--full-width manage-automation-page__r2">
        <div className="bx--col">
          <p className='manage-automation-page__subheading'>Alerts</p>
        </div>
      </div> */}
            <div className="manage-automation-page__r3">
                <div className="bx--col">
                    <p className='padding-top manage-automation-page__subheading carbon-display-Regular-20'>{AlertsLabel}</p>
                </div>
                <div className="manage-automation-page-alerts">
                    <Tabs
                        {...tabProps1.tabs}
                        bx--grid--full-width
                        aria-label="Tab navigation">
                        <Tab {...tabProps1.tab} id='incidents-system' bx--grid--full-width label={IncidentSystem} onClick={handleTabClick}>
                            {Object.keys(props.timeFilterSelections).length !== 0 ?
                                <Suspense fallback={<div></div>}>
                                    <Alerts
                                        filterData={alertFilterData}
                                        headers={alertHeaders}
                                        filterSelections={alertFilterSelections}
                                        timeFilterSelections={props.timeFilterSelections}
                                        disabledSelects={disabledSelects}
                                        updateState={updateState}
                                        status='Ticketed'
                                        alertType='reactive'
                                        workspace={props.workspace}
                                        bx--grid--full-width />
                                </Suspense>
                                :
                                null}
                        </Tab>
                        <Tab {...tabProps1.tab} id='incidents-user' bx--grid--full-width label={IncidentsUser} onClick={handleTabClick}>
                            {loadedTabs.includes('incidents-user') ?
                                <Suspense fallback={<div></div>}>
                                    <Alerts
                                        filterData={alertFilterData}
                                        headers={incidentUserHeaders}
                                        filterSelections={alertFilterSelections}
                                        timeFilterSelections={props.timeFilterSelections}
                                        disabledSelects={disabledSelects}
                                        updateState={updateState}
                                        status='IncidentsUser'
                                        alertType='reactive'
                                        workspace={props.workspace}
                                        bx--grid--full-width />
                                </Suspense>
                                :
                                null}
                        </Tab>
                        <Tab {...tabProps1.tab} id='incidents-buisness' bx--grid--full-width label={IncidentsBuisness} onClick={handleTabClick}>
                            {loadedTabs.includes('incidents-buisness') ?
                                <Suspense fallback={<div></div>}>
                                    <Alerts
                                        filterData={alertFilterData}
                                        headers={incidentBuisnessHeaders}
                                        filterSelections={alertFilterSelections}
                                        timeFilterSelections={props.timeFilterSelections}
                                        disabledSelects={disabledSelects}
                                        updateState={updateState}
                                        status='IncidentsBuisness'
                                        alertType='reactive'
                                        workspace={props.workspace}
                                        bx--grid--full-width />
                                </Suspense>
                                :
                                null}
                        </Tab>
                        <Tab {...tabProps1.tab} id='informational' label={Informational} onClick={handleTabClick}>
                            {loadedTabs.includes('informational') ?
                                <Suspense fallback={<div></div>}>
                                    <Alerts
                                        filterData={alertFilterData}
                                        headers={alertHeaders}
                                        filterSelections={alertFilterSelections}
                                        timeFilterSelections={props.timeFilterSelections}
                                        disabledSelects={disabledSelects}
                                        updateState={updateState}
                                        status='Informational'
                                        alertType='reactive'
                                        workspace={props.workspace}
                                        bx--grid--full-width />
                                </Suspense>
                                : null}
                        </Tab>
                        {/* <Tab {...tabProps1.tab} id='system-recommendations' label={SystemRecommendations} onClick={handleTabClick}>
                            {loadedTabs.includes('system-recommendations') ?
                                <Suspense fallback={<div></div>}>
                                    <Alerts
                                        filterData={alertFilterData}
                                        headers={SystemRecommendationHeaders}
                                        filterSelections={alertFilterSelections}
                                        timeFilterSelections={props.timeFilterSelections}
                                        disabledSelects={disabledSelects}
                                        updateState={updateState}
                                        status='SystemRecommendations'
                                        alertType='sapone'
                                        workspace={props.workspace}
                                        bx--grid--full-width />
                                </Suspense>
                                : null}
                        </Tab> */}
                    </Tabs>
                </div>
            </div>
            <div id={'Predicted_Anomalies'} className="bx--row bx--grid--full-width manage-automation-page__r4">
                {/* <div className="bx--col">
          <p className='manage-automation-page__subheading'>{otherAnomalies}</p>
        </div> */}
            </div>
            <div className="manage-automation-page__r5">
                <div className="bx--col">
                    <p className='padding-top manage-automation-page__subheading carbon-display-Regular-20'>{otherAnomalies}</p>
                </div>
                <div className="manage-automation-page-predictive-alerts">
                    {console.log("pAlertFilterData", pAlertFilterData)}

                    <Tabs
                        {...tabProps2.tabs}
                        selected={selectedIndex}
                        bx--grid--full-width
                        aria-label="Tab navigation">
                        <Tab {...tabProps2.tab} id='infra_failures' bx--grid--full-width label={infraFailures} onClick={handleTabClick}>
                            {Object.keys(props.timeFilterSelections).length !== 0 ?
                                <Suspense fallback={<div></div>}>
                                    <Alerts
                                        filterData={pAlertFilterData}
                                        headers={predictedInfraAlertHeaders}
                                        filterSelections={pAlertFilterSelections}
                                        timeFilterSelections={props.timeFilterSelections}
                                        disabledSelects={disabledSelects}
                                        updateState={updateState}
                                        alertType='Infra Alert'
                                        status='Ticketed'
                                        workspace={props.workspace}
                                        bx--grid--full-width />
                                </Suspense>
                                : null}
                        </Tab>
                        <Tab {...tabProps2.tab} id='log_anomalies' label={logAnomalies} onClick={handleTabClick}>
                            {loadedTabs.includes('log_anomalies') ?
                                <Suspense fallback={<div></div>}>
                                    <Alerts
                                        filterData={pAlertFilterData}
                                        headers={predictedAlertHeaders}
                                        filterSelections={pAlertFilterSelections}
                                        timeFilterSelections={props.timeFilterSelections}
                                        disabledSelects={disabledSelects}
                                        updateState={updateState}
                                        alertType='Log Anomaly'
                                        status='Exception'
                                        workspace={props.workspace}
                                        bx--grid--full-width />
                                </Suspense>
                                : null}
                        </Tab>
                        <Tab {...tabProps2.tab} id='informational' label={Informational} onClick={handleTabClick}>
                            {loadedTabs.includes('informational') ?
                                <Suspense fallback={<div></div>}>
                                    <Alerts
                                        filterData={pAlertFilterData}
                                        headers={infraInformationalHeaders}
                                        filterSelections={pAlertFilterSelections}
                                        timeFilterSelections={props.timeFilterSelections}
                                        disabledSelects={disabledSelects}
                                        updateState={updateState}
                                        alertType='Informational'
                                        status='Informational'
                                        workspace={props.workspace}
                                        bx--grid--full-width />
                                </Suspense>
                                : null}
                        </Tab>
                        {/* <Tab {...tabProps2.tab} id='SecurityAlert' label={securityAlerts} onClick={handleTabClick}>
                            {loadedTabs.includes('SecurityAlert') ?
                                <Suspense fallback={<div></div>}>
                                    <Alerts
                                        filterData={pAlertFilterData}
                                        headers={infraSecurityHeaders}
                                        filterSelections={pAlertFilterSelections}
                                        timeFilterSelections={props.timeFilterSelections}
                                        disabledSelects={disabledSelects}
                                        updateState={updateState}
                                        alertType='SecurityAlert'
                                        status='SecurityAlert'
                                        workspace={props.workspace}
                                        bx--grid--full-width />
                                </Suspense>
                                : null}
                        </Tab> */}
                    </Tabs>
                </div>
            </div>
        </div >
    );
};

export default SAPOpsWorkspace;
